export class ApiError extends Error {
    path: string[];
    statusCode?: number;
    data?: unknown;
    constructor({
        name,
        message,
        path,
        statusCode,
        data
    }: {
        name: string;
        message: string;
        path?: string[];
        statusCode?: number;
        data?: unknown;
    }) {
        super(message);
        this.name = name;
        this.path = path ?? [];
        this.statusCode = statusCode;
        this.data = data;
    }
}
